import emptySnail from 'assets/image/snail-no.png'

import css from './Empty.module.scss'
export function Empty() {
	return (
		<div className={css.root}>
			Mailbox is not available
			<img alt='noResult' height={209} src={emptySnail} width={120} />
		</div>
	)
}
